module.exports = __webpack_public_path__ + "media/4x3/to-79354e72.svg";